import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faExternalLinkAlt, faChevronRight, faSearch,
          faChevronLeft, faCheck, faThumbtack, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronUp);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faExternalLinkAlt);
library.add(faCheck);
library.add(faThumbtack);
library.add(faSearch);
library.add(faTimes);
config.autoAddCss = false;

export default () => {
  Vue.component('font-awesome-icon', FontAwesomeIcon);
};
